var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-icon',{attrs:{"component":_vm.Svg}})
}
var staticRenderFns = []

export { render, staticRenderFns }